import React from 'react'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Headroom from 'react-headroom'
import Menu from 'react-burger-menu'
import Scroll from 'react-scroll'
import { FaGithub, FaLinkedin, FaEnvelopeO } from 'react-icons/lib/fa'
import { config } from 'config'
import '../css/style'
import '../css/hover'
import '../css/burger-menu'
import '../css/markdown-styles'

import { rhythm } from '../utils/typography'


export default class Index extends React.Component {
  propTypes () {
    return {
      children: React.PropTypes.any,
    }
  }

  constructor(props) {
    super(props);
    this.state = { 
      isMenuOpen: false,
      isBrowser: false,
    }; 
  }

  showContactModal() {
    this.refs.modal.show();
  }

  hideContactModal() {
    this.refs.modal.hide();
  }

  renderContactModal() {
    const Modal = require('boron/WaveModal');
    return (
      <Modal ref="modal" keyboard={this.callback}>
        <div className="contact-modal">
          <img src="https://api.mapbox.com/v4/mapbox.comic/pin-s-rocket+6c6c6c(100.5344014,13.7559755)/100.5344014,13.7559755,15/600x300@2x.png?access_token=pk.eyJ1IjoiYXN1bm5vdHRoZXN1biIsImEiOiJjaXd3NnJ3YW8wMGYwMnRtZ2lrbmxlcTlyIn0.J2YR00uuf8vUe4t7whmXqw" />
          <div className="modal-inner">
            <h2>Let's Connect</h2>
            <div className="body">
              <p>Email me at<br />me@soravis.com</p>
              <p>Find me on <a href="https://www.linkedin.com/in/soravis-sun-prakkamakul-8069a549" className="footer-item" target="_blank">LinkedIn</a>, <a href="https://github.com/5un" className="footer-item" target="_blank"> Github</a></p>
            </div>
            <div className="contact-icons">
              <a href="mailto:me@soravis.com"><FaEnvelopeO className="contact-icon"/></a>
              <a href="https://www.linkedin.com/in/soravis-sun-prakkamakul-8069a549" className="footer-item" target="_blank"><FaLinkedin className="contact-icon"/> </a>
              <a href="https://github.com/5un" className="footer-item" target="_blank"><FaGithub className="contact-icon"/></a>
            </div>
            <button className="btn btn-blue-stone-gray" onClick={() => {this.hideContactModal()}}>Close</button>
          </div>
        </div>
      </Modal>
    );
  }

  componentDidMount() {
    this.setState({isBrowser: true});
  }

  render () {
    let isHome = this.props.location.pathname === '/';
    let ScrollLink = Scroll.Link;
    let enableBlog = config.enableBlog || false;
    let enableLife = config.enableLife || false;

    return (
      <div>
        <Menu.elastic isOpen={this.state.isMenuOpen}>
          <ul className="sidebar">
            <li>
              <Link 
                className="sidebar-nav-item hvr-underline-from-center hvr-fuchsia-blue"
                to={prefixLink('/')}
                style={{
                  color: 'white',
                  textDecoration: 'none',
                }}
              >
                HELLO
              </Link>
            </li>

            {enableBlog &&
              <li>
                <Link 
                  className="sidebar-nav-item hvr-underline-from-center hvr-bright-turquoise"
                  to={prefixLink('/blog/')}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                >
                  BLOG
                </Link>
              </li>
            }

            <li>
              <Link className="sidebar-nav-item hvr-underline-from-center hvr-bright-turquoise"
                to={prefixLink('/works/')}
                style={{
                  color: 'white',
                  textDecoration: 'none',
                }}
              >
                WORKS
              </Link>
            </li>

            <li>
              <Link className="sidebar-nav-item hvr-underline-from-center hvr-malibu"
                to={prefixLink('/about/')}
                style={{
                  color: 'white',
                  textDecoration: 'none',
                }}
              >
                ABOUT
              </Link>
            </li>

            <li>
            <a className="sidebar-nav-item hvr-underline-from-center hvr-purple-pizzazz"
                href={prefixLink('/files/soravis-resume-20171024.pdf')}
                target="_blank"
                style={{
                  color: 'white',
                  textDecoration: 'none',
                }}
              >
                RESUME
              </a>
            </li>

            <li>
              <a className="sidebar-nav-item hvr-underline-from-center hvr-fuchsia-blue"
                onClick={() => {this.showContactModal()}}
                style={{
                  color: 'white',
                  textDecoration: 'none',
                }}
              >
                CONTACTS
              </a>
            </li>

            {enableLife &&
              <li>
                <Link 
                  className="sidebar-nav-item hvr-underline-from-center hvr-bright-turquoise"
                  to={prefixLink('/life/')}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                >
                  LIFE
                </Link>
              </li>
            }

          </ul>
        </Menu.elastic>
        <Headroom disableInlineStyles={true}
          wrapperStyle={{
            height: 0
          }}
          style={{
            zIndex: 1
          }}
        >
          
          <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >
            <Grid columns={12} className="navbar">
              <Breakpoint minWidth={800} widthMethod="componentWidth">
                <Span columns={4} className="nav-left">
                  <Link
                    className="nav-branding"
                    to={prefixLink('/')}
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                    }}
                  >
                    SORAVIS
                  </Link>
                </Span>
                <Span columns={8} last className="nav-right">
                  {enableBlog &&
                    <Link 
                      className="nav-item hvr-underline-from-center hvr-bright-turquoise"
                      to={prefixLink('/blog/')}
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                      }}
                    >
                      BLOG
                    </Link>
                  }
                  {isHome &&
                    <ScrollLink className="nav-item hvr-underline-from-center hvr-bright-turquoise"
                      to="works"
                      smooth={true}
                      duration={500}
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      WORKS
                    </ScrollLink>
                  }
                  {!isHome &&
                    <Link className="nav-item hvr-underline-from-center hvr-bright-turquoise"
                      to={prefixLink('/works/')}
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                      }}
                    >
                      WORKS
                    </Link>
                  }
                  <Link className="nav-item hvr-underline-from-center hvr-malibu"
                    to={prefixLink('/about/')}
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                    }}
                  >
                    ABOUT
                  </Link>
                  <a className="nav-item hvr-underline-from-center hvr-purple-pizzazz"
                    href={prefixLink('/files/soravis-resume-20171024.pdf')}
                    target="_blank"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                    }}
                  >
                    RESUME
                  </a>
                  <a className="nav-item hvr-underline-from-center hvr-fuchsia-blue"
                    onClick={() => {this.showContactModal()} }
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                    }}
                  >
                    CONTACT
                  </a>
                  {enableLife &&
                    <Link 
                      className="nav-item hvr-underline-from-center hvr-fuchsia-blue"
                      to={prefixLink('/life/')}
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                      }}
                    >
                      LIFE
                    </Link>
                  }
                </Span>
              </Breakpoint>
              <Breakpoint maxWidth={800} widthMethod="componentWidth" className="nav-center">
                <Link
                  to={prefixLink('/')}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                >
                  SORAVIS
                </Link>
              </Breakpoint>
            </Grid>
          </Container>
        </Headroom>
        {this.props.children}
        <div className="footer">
          <p>Contact</p>
          <a href="https://www.linkedin.com/in/soravis-sun-prakkamakul-8069a549" className="footer-item" target="_blank">LinkedIn</a>
          {/*
            <a href="https://twitter.com/asunnotthesun" className="footer-item">Twitter</a>
          */}
          <a href="https://github.com/5un" className="footer-item" target="_blank">Github</a>
          <a href="mailto:me@soravis.com" className="footer-item" target="_blank">Email</a>
          <br />
          <span className="copyright-text">Soravis Prakkamakul 2016, All rights reserved.</span>
        </div>
        {this.state.isBrowser && this.renderContactModal()}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./_template.jsx
 **/